/**
 * Widget HotelOffer
 */

// Styles
import('../css/hotel_offer.scss');

var hotelOffersElem = document.querySelector('.wdgt-HotelOffer');

if (hotelOffersElem) {
    var ck24_imageGallery = null;

    var getImageGallery = function(galleryId, galleryTagId) {
        return new Promise(function(resolve, reject) {
            if (galleryId) {
                if (ck24_imageGallery === null) {
                    import('../../../../assets/frontend/js/tcms_base_imageGallery.class.js').then(
                        function(Ck24_ImageGallery) {
                            Ck24_ImageGallery = Ck24_ImageGallery.default;

                            ck24_imageGallery = new Ck24_ImageGallery({
                                galleryId: galleryId,
                                galleryTagId: galleryTagId,
                                lazyloader: window.c24_lazyloadLibs.lazyLoad
                            });

                            resolve(ck24_imageGallery);
                        }
                    );
                } else {
                    resolve(ck24_imageGallery);
                }
            } else {
                reject(new Error('Gallery ID missing'));
            }
        });
    };
    var hotelOfferBoxElem = hotelOffersElem.querySelector('.hotel-offer-box');

    if (hotelOfferBoxElem) {
        var galleryId = hotelOfferBoxElem.dataset.galleryId;
        var galleryTagId = hotelOfferBoxElem.dataset.galleryTagId;
    }

    // Enable click on Hotel Info Header without opening gallery
    document.querySelector('.hotel-header').addEventListener('click', function(e) {
        e.stopPropagation();
    });

    // Init Gallerys
    var offerPictureElem = hotelOffersElem.querySelector(
        '.ck24-imageGallery.js-wt-HotelOfferGalleryTrigger.hotel-header-wrapper'
    );

    if (offerPictureElem) {
        // Main Big Image
        offerPictureElem.addEventListener('click', function(e) {
            e.preventDefault();
            getImageGallery(galleryId, galleryTagId)
                .then(function(ig) {
                    ig.open();
                })
                .catch(function(e) {
                    console.error(e);
                });
        });
    }

    // Small little boxes on the right
    var offerGalleryThumbs = hotelOffersElem.querySelectorAll(
        '.ck24-imageGallery.js-wt-HotelOfferGalleryTrigger.thumbnails li'
    );

    offerGalleryThumbs.forEach(function(liElem) {
        liElem.addEventListener('click', function(e) {
            e.preventDefault();
            var el = this;

            getImageGallery(galleryId, galleryTagId)
                .then(function(ig) {
                    ig.open(el.dataset.imgIndex, el.dataset.galleryRelation);
                })
                .catch(function(e) {
                    console.error(e);
                });
        });
    });
}
